export let isNewScheduledOrderCycleEnabled = false;

// Comente a linha abaixo para desativar o novo fluxo de pedidos programados no frontend.
isNewScheduledOrderCycleEnabled = true;

export const isNewScheduledOrderCycleEnabledForCycle = (
  cycleYear?: number | null,
): boolean =>
  isNewScheduledOrderCycleEnabled && cycleYear != null && cycleYear >= 2027;
